import angular from 'angular';
import moment from 'moment';

angular
  .module('cxInvoicing')
  .controller('NumberInvoicesDialogCtrl', [
    '$element',
    'close',
    'filters',
    'batchParams',
    'bookyearinfos',
    'invoicesOrCreditNotes',
    'appUrls',
    'dataCache',
    '$http',
    'flySvc',
    numberInvoicesDialogCtrl,
  ]);

const maxDate = (a, b) => {
  if (!a) return b;
  if (!b) return a;
  if (moment(a).isBefore(b)) return b;
  return a;
};

const maxDateProp = (array, prop) =>
  array.reduce((max, item) => (max ? maxDate(max, item[prop]) : item[prop]), null);

function numberInvoicesDialogCtrl(
  $element,
  close,
  filters,
  batchParams,
  bookyearinfos,
  invoicesOrCreditNotes,
  appUrls,
  dataCache,
  $http,
  flySvc,
) {
  var vm = this;
  vm.numbering = false;
  vm.dateToNumber = null;
  vm.send = false;
  vm.isFuture = false;
  vm.numberZeroInvoices = false;

  dataCache.ready().then(() => {
    vm.send = dataCache.getDefaultCompany().autoSendInvoices;
  });
  vm.multipleCompanies = bookyearinfos.length > 1;

  //Init bookyear info
  if (invoicesOrCreditNotes === 1) {
    // Only invoices
    // Only allow previous bookyear if there is only one
    vm.boundaryPreviousBookyear =
      bookyearinfos.length === 1 ? bookyearinfos[0].lastInvoiceDatePreviousBookyear : null;
    // Take max of all bookyears
    vm.boundaryCurrentBookyear = maxDateProp(bookyearinfos, 'lastInvoiceDateCurrentBookyear');
  } else if (invoicesOrCreditNotes === 2) {
    // Only credit notes
    // Only allow previous bookyear if there is only one
    vm.boundaryPreviousBookyear =
      bookyearinfos.length === 1 ? bookyearinfos[0].lastCreditnoteDatePreviousBookyear : null;
    // Take max of all bookyears
    vm.boundaryCurrentBookyear = maxDateProp(bookyearinfos, 'lastCreditnoteDateCurrentBookyear');
  } else {
    // Both or unknown, so taking max date of both
    // Only allow previous bookyear if there is only one
    vm.boundaryPreviousBookyear =
      bookyearinfos.length === 1
        ? maxDate(
            bookyearinfos[0].lastInvoiceDatePreviousBookyear,
            bookyearinfos[0].lastCreditnoteDatePreviousBookyear,
          )
        : null;
    // Take max of all bookyears
    vm.boundaryCurrentBookyear = maxDate(
      maxDateProp(bookyearinfos, 'lastCreditnoteDateCurrentBookyear'),
      maxDateProp(bookyearinfos, 'lastInvoiceDateCurrentBookyear'),
    );
  }
  vm.endDatePreviousBookyear =
    bookyearinfos.length === 1 ? bookyearinfos[0].endDatePreviousBookyear : null;

  vm.dateToNumber = moment
    .utc()
    .startOf('day')
    .toDate();

  vm.dateToNumberChanged = function(date) {
    if (!date) {
      vm.isFuture = false;
      vm.dateToNumber = moment
        .utc()
        .startOf('day')
        .toDate();
    } else {
      vm.isFuture = moment(date).isAfter(moment.utc(), 'day');
    }
    if (vm.isFuture) vm.send = dataCache.getDefaultCompany().autoSendInvoices;
  };

  vm.save = function() {
    if (vm.numbering || !vm.dateToNumber) return;
    vm.numbering = true;
    $http
      .post(
        `${appUrls.api}/api/draftinvoice/finalizeAll`,
        {
          ...batchParams,
          dateToNumber: vm.dateToNumber.ISO(),
          send: vm.send,
          numberZeroInvoices: vm.numberZeroInvoices,
        },
        { params: filters },
      )
      .then(
        function({ data }) {
          vm.numbering = false;
          $element.modal('hide');
          close(data, 500);
        },
        function(error) {
          vm.numbering = false;
          flySvc.error(error.data.code, error.data.parameters);
        },
      );
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
